import React from 'react'
import AdsPage from '..'

const InternetBankingAdsPage = () => {
  return (
    <AdsPage />
  )
}

export default InternetBankingAdsPage